import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Typography, Divider, Box } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import i18next from 'i18next';
import CloseIcon from '@mui/icons-material/Close';
import ModelCopeLink from './../../global/ModelCopeLink';
import ModelQrCode from './../../global/ModelQrCode';
import { ReactComponent as CopyIcon } from './../../../assets/icons/copyLink.svg';
import { ReactComponent as Qr } from './../../../assets/icons/qrCode.svg';
// import { ReactComponent as SheerIcon } from './../../../assets/icons/shereLink.svg';
import { ReactComponent as Reating } from './../../../assets/icons/Reating.svg';
import { ReactComponent as Correspondence } from './../../../assets/icons/Correspondence.svg';
import Btn from '../../global/Btn';
import { useTranslation } from 'react-i18next';
// import { useSendStoreLogs } from '../../../hooks/StoreLogs/useSendStoreLogs';
import ShareButton from '../../global/Share/ShareNavButton';

const DropdownMenu = ({ children, data }) => {
    // const { storeLogs: sendLogs } = useSendStoreLogs()

    const { slug } = useParams()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const navigate = useNavigate()
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const theme = useTheme()
    let lng = i18next.language
    const [openCopeLink, setOpenCopeLink] = useState(false);
    const handleClickOpenCopeLink = () => setOpenCopeLink(true);
    const [openQr, setOpenQr] = useState(false);
    const handleClickOpenQr = () => {
        setOpenQr(true);
    };
    const fallUrl = `https://fasterlink.me/${slug}`

    // const shareQRCodeDirect = () => {
    //     sendLogs('shares')
    //     const qrUrl = `https://wa.me/?text=${encodeURIComponent(fallUrl)}`;
    //     window.open(qrUrl, '_blank');
    // };
    const { t, i18n } = useTranslation()
    return (
        <>
            <IconButton onClick={handleClick} sx={{ ':hover': { background: 'none' }, color: 'inherit' }}>
                {children}
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                sx={{
                    '.MuiMenu-list': {
                        borderTop: `5px solid ${theme.palette.secondary.main}`,
                        backgroundColor: 'rgb(32,32,32, 90%)',
                    },
                    '.MuiMenu-paper': {
                        // borderTop: `5px solid ${theme.palette.secondary.main}`,
                        backgroundColor: 'transparent',
                    },
                    padding: 0,
                }}
            >
                <IconButton onClick={handleClose} sx={{ color: '#fff' }}>
                    <CloseIcon />
                </IconButton>
                <MenuItem onClick={handleClose} >
                    <IconButton
                        onClick={handleClickOpenCopeLink}
                        className="link"
                        sx={{ flexDirection: 'row', gap: 2 }}
                    >
                        <CopyIcon className={'svg'} />
                        <Typography color={'primary.text'} >
                            {lng === 'ar' ? 'نسخ الرابط' : 'Share Link'}
                        </Typography>
                    </IconButton>
                </MenuItem>
                <MenuItem onClick={handleClose} >
                    <IconButton
                        onClick={handleClickOpenQr}
                        className="link"
                        sx={{ flexDirection: 'row', gap: 2 }}
                    >
                        <Qr className={'svg'} />
                        <Typography color={'primary.text'} >
                            {lng === 'ar' ? 'رمز Qr' : 'Qr Code'}
                        </Typography>
                    </IconButton>
                </MenuItem>
                <MenuItem onClick={handleClose} >
                    {/* <IconButton
                        onClick={''}
                        className="link"
                        sx={{ flexDirection: 'row', gap: 2 }}
                    > */}
                    {/* <SheerIcon className={'svg'} /> */}
                    <ShareButton
                        sx={{ flexDirection: 'row', gap: 2 }}
                        main_url={fallUrl}
                        name={data?.name}
                    />
                    <Typography color={'primary.text'} >
                        {lng === 'ar' ? 'مشاركة' : 'share'}
                    </Typography>
                    {/* </IconButton> */}
                </MenuItem>
                <MenuItem onClick={handleClose} >
                    <IconButton
                        onClick={() => navigate(`/${slug}/add-review`)}
                        className="link"
                        sx={{ flexDirection: 'row', gap: 2 }}
                    >
                        <Reating className={'svg'} />
                        <Typography color={'primary.text'} >
                            {lng === 'ar' ? 'تقييم' : 'evaluation'}
                        </Typography>
                    </IconButton>
                </MenuItem>
                <MenuItem onClick={handleClose} >
                    <IconButton
                        onClick={() => navigate(`/${slug}/correspondence`)}
                        className="link"
                        sx={{ flexDirection: 'row', gap: 2 }}
                    >
                        <Correspondence className={'svg'} />
                        <Typography color={'primary.text'} >
                            {lng === 'ar' ? 'المراسلة' : 'Correspondence'}
                        </Typography>
                    </IconButton>
                </MenuItem>
                <Divider sx={{
                    my: 1, borderColor: theme => theme.palette.background.tap
                }} />
                <MenuItem
                    sx={{
                        justifyContent: 'center',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        gap: 1,
                        py: 1,
                        opacity: 1
                    }}>
                    <Box sx={{ flex: 1, borderBottom: `1px solid ${theme.palette.primary.text}` }} />
                    <Box component={Link}
                        target='_blank'
                        to={`https://business.fasterlink.me/register/vendor?lng=${i18n.language}`}
                        sx={{ width: 'fit-content', m: 'auto' }}>
                        <Btn width='275px' sx={{
                            background: theme => theme.palette.background.date, height: '35px',
                            color: theme.palette.primary.default
                        }}>
                            <Typography color={'primary.default'} variant='body1'>
                                {t("createYourStore")}
                            </Typography>
                        </Btn>
                    </Box>
                </MenuItem>
            </Menu>
            <ModelCopeLink openDialog={openCopeLink}
                setOpenDialog={setOpenCopeLink} slug={slug} />
            <ModelQrCode openDialog={openQr}
                setOpenDialog={setOpenQr} data={data} slug={slug} />
        </>
    );
};

export default DropdownMenu;
